import { Controller, Application } from 'stimulus';

const PASSWORD_INPUT_TYPE = 'password';

class PasswordInputController extends Controller {
  static targets = ['input', 'icon'];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly iconTarget: HTMLInputElement;

  private get isHidden() : boolean {
    return this.inputTarget.type === PASSWORD_INPUT_TYPE;
  }

  initialize(): void {
    this.toggleIcon();
    this.initElementsEventListeners();

    this.inputTarget.type = PASSWORD_INPUT_TYPE;
  }

  toggle(e: Event): void {
    e.preventDefault();
    const targetType = this.isHidden ? 'text' : PASSWORD_INPUT_TYPE;
    this.toggleIcon();
    this.inputTarget.type = targetType;
    this.inputTarget.focus();
  }

  private toggleIcon() {
    this.iconTarget.classList.toggle('c-icon--show-password', this.isHidden);
    this.iconTarget.classList.toggle('c-icon--hide-password', !this.isHidden);
  }

  private initElementsEventListeners() {
    // To prevent unnecessary validation, this declaration prevent raising focusout event on input element
    this.iconTarget.addEventListener('mousedown', (e) => {
      e.preventDefault();
    });
  }
}

export function registerPasswordInput(application: Application): void {
  application.register('passwordInput', PasswordInputController);
}
